import { Cookie } from "@modules/util/Cookie"
import { updateUrl } from "@modules/util/url"

const orderedAdvertsCookie = new Cookie("orderedAdvertsConfig", {
    path: "/",
    domain: SiteInfo.cookieDomain,
})

document.addEventListener("mousedown", (event) => {
    const cardWithNextPreviousId = getNextPreviousCard(event.composedPath())

    if (!cardWithNextPreviousId) {
        return null
    }

    let pageElement = cardWithNextPreviousId.previousElementSibling
    while (!pageElement?.hasAttribute("data-page") && pageElement !== null) {
        pageElement = pageElement?.previousElementSibling || null
    }
    const page = pageElement?.getAttribute("data-page")
    if (page) {
        const newUrl = new URL(window.location.href)
        newUrl.searchParams.set("page", page)
        updateUrl(newUrl.href)
    }

    const previousNextId = cardWithNextPreviousId.getAttribute("data-next-previous-id")
    orderedAdvertsCookie.expires = Cookie.getExpireDate(3600 * 24)
    orderedAdvertsCookie.value = {
        currentOrderedId: previousNextId,
        currentOrderedReferrer: "contentcatalog-anzeigenmarkt",
        currentBacklinkAdvertUrl: window.location.href,
        currentSearchHash: SiteInfo.currentSearchHash,
    }
})

document.addEventListener("click", (event) => {
    const cardWithNextPreviousId = getNextPreviousCard(event.composedPath())

    if (!cardWithNextPreviousId) {
        return null
    }

    localStorage.setItem("scrollToPreviousNextId", cardWithNextPreviousId.getAttribute("data-next-previous-id") || "")
})

export function getNextPreviousCard(elements: EventTarget[]) {
    let cardWithNextPreviousId = null
    for (const element of elements) {
        if (element instanceof HTMLElement && element.hasAttribute("data-next-previous-id")) {
            cardWithNextPreviousId = element
            break
        }
    }

    if (!cardWithNextPreviousId) {
        return null
    }
    return cardWithNextPreviousId
}

export function scrollToPreviousNextCard(prevNextId: string, block: "center" | "end" | "start" = "center") {
    window.history.scrollRestoration = "manual"
    setTimeout(() => {
        const target = document.querySelector(`[data-next-previous-id="${prevNextId}"]`)
        if (!target) {
            tryRestoreLastScrollPositionAzm()
            return
        }
        target?.scrollIntoView({
            behavior: "instant",
            block,
        })
    }, 250)
}

export function tryRestoreLastScrollPositionAzm() {
    const scrollingLastPrevNextCard = localStorage.getItem("scrollingLastPrevNextCard")
    if (scrollingLastPrevNextCard) {
        localStorage.removeItem("scrollingLastPrevNextCard")
        const parsed = JSON.parse(scrollingLastPrevNextCard)
        scrollToPreviousNextCard(parsed.prevNextId, parsed.block)
        return true
    }
    return false
}
